import React from "react";
import { Link } from "react-router-dom";
import { Leaf, Search } from "lucide-react";
import useSEO from "@/hooks/useSEO";

const NotFoundPage = () => {
  useSEO({
    title: "Page not found | Ecowallet",
    description: "The page you're looking for doesn't exist. Explore Ecowallet's sustainable products, sustainability scores and rewards instead.",
    noindex: true,
  });
  return (
    <div className="max-w-3xl mx-auto px-6 py-24 text-center">
      <div className="grid place-items-center h-16 w-16 rounded-full bg-emerald-100 text-emerald-700 dark:bg-emerald-900/40 dark:text-emerald-300 mx-auto">
        <Leaf className="h-8 w-8" />
      </div>
      <h1 className="mt-6 text-5xl font-bold tracking-tight">404</h1>
      <p className="mt-3 text-xl text-muted-foreground">This page has gone off-grid.</p>
      <p className="mt-5 max-w-md mx-auto text-sm text-muted-foreground">
        The page you're looking for doesn't exist. Head back home or explore sustainable products, sustainability scores and rewards.
      </p>
      <div className="mt-8 flex flex-wrap gap-3 justify-center">
        <Link to="/" className="btn-pill bg-primary text-primary-foreground">Back to home</Link>
        <Link to="/products" className="btn-pill border border-border bg-card">
          <Search className="h-4 w-4 mr-1" /> Explore products
        </Link>
      </div>
      <div className="mt-12 grid sm:grid-cols-2 gap-3 text-left">
        {[
          { to: "/sustainability-score", label: "What is a sustainability score?" },
          { to: "/methodology", label: "How we score products" },
          { to: "/greenwashing", label: "Detect greenwashing" },
          { to: "/blog", label: "Read the blog" },
        ].map((l) => (
          <Link key={l.to} to={l.to} className="card-premium p-4 hover:-translate-y-1 transition-all text-sm font-semibold">
            {l.label} →
          </Link>
        ))}
      </div>
    </div>
  );
};

export default NotFoundPage;
